import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ciHttpRequest } from '../../../utils/CiHttpRequest';
import { ISaleRoSearch, ISaleRoDetail, ISaleRoStatistics } from './vrmBillSaleRoType';
import { IPage } from '@/types/FmsTypes';
export interface IVRM2DictSearchs {
	pageSize: number;
	pageNum: number;
	sourceApp?: string;
	branch?: string;
	shopCode?: string;
}

export interface IVRM2DictDetail {
	branch: string;
	branchList: any | null;
	ver: number;
	enable: number;
	dictType: null;
	code: string;
	name: string;
	nameEn: string | null;
	value: string;
	pcode: string | null;
	note: string;
	status: number;
	children: IVRM2DictDetail[];
	shopCode?: string | any;
	key: string;
}

class SaleRoService {

	async one(returnCode: string,userBranch:string) {
		const apiUrl =userBranch=='vrm'?`/vrm2/sreturn/findById/${returnCode}`: `/ci-storage/sreturn/findById/${returnCode}`;
		return await  userBranch=='vrm'?appHttpRequest.get<ISaleRoDetail>(apiUrl): ciHttpRequest.get<ISaleRoDetail>(apiUrl);
	}

	//树列表
	//门店树列表
	async pages(searchVo: IVRM2DictSearchs) {
		const apiUrl = '/vrm2/base/dict/pages';
		return await appHttpRequest.post<IVRM2DictDetail[]>(apiUrl, searchVo);
	}
}

export const saleRoService = new SaleRoService();
